import { z } from 'zod';
import { moneyCents, objectIdString } from './common.js';

// POST /broker/sales · broker marks a sale closed for a given lead.
// Fires a `Purchase` event into Meta CAPI on success.
export const createSaleInput = z
  .object({
    leadId: objectIdString,
    propertyId: objectIdString.optional(),
    unitNumber: z.string().trim().max(40).optional(),
    contractValueCents: moneyCents,
    commissionValueCents: moneyCents.optional(),
    contractDate: z.coerce.date(),
  })
  .strict();

export type CreateSaleInput = z.infer<typeof createSaleInput>;
